import { render, staticRenderFns } from "./assignments_view.vue?vue&type=template&id=0824ccda&scoped=true&"
import script from "./assignments_view.vue?vue&type=script&lang=js&"
export * from "./assignments_view.vue?vue&type=script&lang=js&"
import style0 from "./assignments_view.vue?vue&type=style&index=0&id=0824ccda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824ccda",
  null
  
)

export default component.exports